import React, { useState } from "react";
import { Filter, ChevronDown } from "lucide-react";
import { Button } from "components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";

interface StatusOption {
  value: string;
  label: string;
  description: string;
}

interface StatusFilterDropdownProps {
  statusFilter: string[];
  setStatusFilter: (filter: string[]) => void;
  availableStatuses: StatusOption[];
}

const StatusFilterDropdown = ({
  statusFilter,
  setStatusFilter,
  availableStatuses,
}: StatusFilterDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 text-xs">
          <Filter className="mr-2 h-3 w-3" />
          Status
          {statusFilter.length > 0 && (
            <span className="ml-1 bg-blue-100 text-blue-800 rounded-full px-1.5 py-0.5 text-xs">
              {statusFilter.length}
            </span>
          )}
          <ChevronDown className="ml-1 h-3 w-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-0" align="start">
        <div className="p-2">
          <div className="text-sm font-medium text-gray-700 mb-2">
            Filter by Status
          </div>
          <div className="space-y-1 max-h-64 overflow-y-auto">
            {availableStatuses.map((status) => (
              <label
                key={status.value}
                className="flex items-start space-x-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
              >
                <div className="flex items-center h-5">
                  <input
                    type="checkbox"
                    className="h-3 w-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    checked={statusFilter.includes(status.value)}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (e.target.checked) {
                        setStatusFilter([...statusFilter, status.value]);
                      } else {
                        setStatusFilter(
                          statusFilter.filter((s) => s !== status.value)
                        );
                      }
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-medium text-gray-900">
                    {status.label}
                  </div>
                  <div className="text-xs text-gray-500">
                    {status.description}
                  </div>
                </div>
              </label>
            ))}
          </div>
          {statusFilter.length > 0 && (
            <div className="mt-2 pt-2 border-t border-gray-100">
              <button
                onClick={() => setStatusFilter([])}
                className="text-xs text-gray-500 hover:text-gray-700"
              >
                Clear filters
              </button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default StatusFilterDropdown;
